module.exports = __webpack_public_path__ + "img/google-play@3x.880bf471.png";